jQuery(document).ready(function ($) {

    $(function () {
        // Clean menu links
        $('#menu-main-menu > li.menu-item > a:not(.solutions-menu-item)').attr('href', '#').click(
            function (e) {
                e.preventDefault();
                var menu_item = $(this).parent('li.menu-item');
                if (menu_item.find('.wp-megamenu-sub-menu').length !== 0 &&
                    !menu_item.hasClass('current-menu-parent')) {
                    $('#menu-main-menu > li.menu-item').removeClass('current-menu-parent');
                    menu_item.addClass('current-menu-parent');
                    $('#menu-main-menu > li.menu-item > a').addClass('custom_class_menu_hover');
                    $('.estore-link a, .all-access-link a').addClass('custom_class_menu_hover');

                } else if (e.target.classList.contains('not-anchor')) {
                    menu_item.removeClass('current-menu-parent');
                    $('#menu-main-menu > li.menu-item > a').removeClass('custom_class_menu_hover');
                    $('.estore-link a, .all-access-link a').removeClass('custom_class_menu_hover');

                }
            }
        );

        $('#menu-main-menu > li.menu-item').hover(
            function () {
                if ($('#menu-main-menu > li.menu-item.current-menu-parent').is('li')) {
                    $('#menu-main-menu > li.menu-item').removeClass('hover-menu-parent');
                    $(this).addClass('hover-menu-parent').children('a');
                }
            }
        );

        $('.wp-megamenu').mouseleave(
            function () {
                window.menuHoverTimeoutId = setTimeout(function () {
                    $('#menu-main-menu > li.menu-item').removeClass('current-menu-parent');
                    $('#menu-main-menu > li.menu-item > a').removeClass('custom_class_menu_hover');
                    $('#menu-main-menu > li.menu-item').removeClass('hover-menu-parent');
                    $('.estore-link a, .all-access-link a').removeClass('custom_class_menu_hover');

                }, '500');
            }
        );

        $('#menu-main-menu > li.menu-item').mouseover(function () {
            if (window.menuHoverTimeoutId != undefined && window.menuHoverTimeoutId != null) {
                clearTimeout(window.menuHoverTimeoutId);
            }
        }
        );

        // Hide menu when click another place.
        window.addEventListener('click', function (e) {
            const menu = document.querySelector('#menu-main-menu');
            if (!menu.contains(e.target)) {
                $('#menu-main-menu > li.menu-item').removeClass('current-menu-parent');
                $('#menu-main-menu > li.menu-item > a').removeClass('custom_class_menu_hover');
                $('#menu-main-menu > li.menu-item').removeClass('hover-menu-parent');
                $('.estore-link a, .all-access-link a').removeClass('custom_class_menu_hover');

            }
        });
        // Hide menu when scroll window.
        window.addEventListener('scroll', function () {
            if ($('#menu-main-menu > li.menu-item.current-menu-parent').is('li')) {
                $('#menu-main-menu > li.menu-item').removeClass('current-menu-parent');
                $('#menu-main-menu > li.menu-item > a').removeClass('custom_class_menu_hover');
                $('#menu-main-menu > li.menu-item').removeClass('hover-menu-parent');
                $('.estore-link a, .all-access-link a').removeClass('custom_class_menu_hover');

            }
        });
    });

    // Behaviors for mobile menu (burger menu)
    $(function () {
        var navbar_mobile = document.getElementById("navbar-mobile");
        document.querySelector('.navbar-toggler.close-nav').addEventListener('click', function () {
            navbar_mobile.classList.remove("showed");
        });
        document.querySelector('.navbar-toggler.open-nav').addEventListener('click', function () {
            navbar_mobile.classList.add("showed");
        });
    });

    /* Change the default behavior of the secondary menu found on the main category pages */

    $(window).scroll(function () {
        if ($(window).width() > 991 && !$('body').is('.products-template-templates.products-template')) {
            $('.category-navigation').addClass('sticky-menu');
            $('#nav-main').hide();
            var scrolled_val = $(document).scrollTop().valueOf();
            if (scrolled_val == 0) {
                $('.category-navigation').removeClass('sticky-menu');
                $('#nav-main').show();
            }
        }
    });

    if ($('.share-container').length > 0) {
        $('.share-trigger').on('click', function () {
            $(this).toggleClass('active');
            $('.socials').toggleClass('open');
        });
        $('.copy-to-clipboard').click(function () {
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val(window.location.href).select();
            document.execCommand('copy');
            $temp.remove();
            var $confirmation = $(this).siblings('.copy-confirmation');
            $confirmation.fadeIn();
            setTimeout(function () {
                $confirmation.fadeOut();
            }, 2000);
        });
    }
    $('.archive-grid, .related-articles, .taos-journal-container').on('mouseenter', '.archive-card, .article', function () {
        $(this).find('.tag-container').stop(true, true).slideDown();
    }).on('mouseleave', '.archive-card, .article', function () {
        $(this).find('.tag-container').stop(true, true).slideUp();
    });
    $('.artists-of-sound-container').on('mouseenter', '.archive-card', function () {
        $(this).find('.text-container').stop(true, true).slideDown();
    }).on('mouseleave', '.archive-card', function () {
        $(this).find('.text-container').stop(true, true).slideUp();
    });

    function isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    function checkVisibility() {
        $(".wp-block-cover__inner-container, .wp-block-group p.has-text-align-center, .highlighted-certified-venues .venue-info, .wp-block-heading, .wp-block-columns p, .awards-section, .grid-section-with-gradient, .wp-block-quote p, .wp-block-media-text, .background-with-quote, .wp-block-group .wp-block-columns, .tab-selectors .tab-content-inner, .background-images-with-descriptions .slide-info").each(function () {
            let elementTop = $(this).offset().top;
            let elementHeight = $(this).outerHeight();
            let elementMid = elementTop + elementHeight / 2;
            let windowTop = $(window).scrollTop();
            let isMobileDevice = isMobile() || $(window).width() < 1200;
            let offset = isMobileDevice ? 0 : 100;
            let windowBottom = windowTop + $(window).height() - offset;
            let triggerPoint = isMobileDevice ? elementTop - 100 : elementMid;

            if (triggerPoint < windowBottom) {
                $(this).addClass("visible");
            }
        });
    }

    // Run on scroll and on page load
    $(window).on("scroll", checkVisibility);
    checkVisibility();
    if ($('body .awards-section').length > 0) {
        $('.awards-carousel-container').slick({
            centerMode: true,
            centerPadding: "200px",
            dots: false,
            arrows: false,
            infinite: true,
            slidesToShow: 3,
            autoplay: true,
            autoplaySpeed: 1000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        centerPadding: "100px",
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        centerPadding: "60px",
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: "80px",
                    }
                }, {
                    breakpoint: 280,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: "80px",
                    }
                }
            ]
        });
    }
    if ($('body .kpis-section').length > 0) {
        $('.kpis-carousel-container').slick({
            // centerMode: true,
            // centerPadding: "200px",
            dots: true,
            arrows: false,
            infinite: false,
            slidesToShow: 3,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        centerPadding: "100px",
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        centerPadding: "60px",
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: "80px",
                    }
                }, {
                    breakpoint: 280,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: "80px",
                    }
                }
            ]
        });
    }

    if ($('body .slider-timeline-section').length > 0) {
        const $carousel = $('.timeline-carousel-container');
        const totalSlides = $carousel.find('.slider-section-container').length;
        $carousel.slick({
            infinite: false,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
        });
        function updateArrowVisibility() {
            const $activeContainer = $('.slider-section-container.slick-current');
            const currentIndex = $activeContainer.data('slick-index');

            const $nextArrow = $('.custom-arrow.next');
            const $prevArrow = $('.custom-arrow.prev');

            console.log("Current index: ", currentIndex);

            if (currentIndex === 0) {
                $prevArrow.addClass('dont-show').removeClass('show');
            } else {
                $prevArrow.removeClass('dont-show').addClass('show');
            }

            const $dates = $activeContainer.find('.date');
            const allDatesShown = $dates.length > 0 && $dates.not('.show').length === 0;

            if (allDatesShown && currentIndex < totalSlides - 1) {
                $dates.last().addClass('show-line');

                $nextArrow.removeClass('dont-show').addClass('show');
            } else {
                $nextArrow.addClass('dont-show').removeClass('show');
            }

            if (currentIndex === totalSlides - 1) {
                $nextArrow.addClass('dont-show').removeClass('show');
            }
        }

        $carousel.on('afterChange', function () {
            updateArrowVisibility();
        });
        $('.slider-section-container').each(function () {
            const $container = $(this);
            const $dates = $container.find('.date');
            const $nextArrow = $('.custom-arrow.next');
            const $prevArrow = $('.custom-arrow.prev');
            let dateIndex = 0;

            $container.on('click', function () {
                if (dateIndex < $dates.length) {
                    // Show next date with fade-in effect
                    $($dates[dateIndex]).removeClass('dont-show').addClass('show');
                    console.log("dates: ", $dates);
                    if (dateIndex > 0) {
                        $($dates[dateIndex - 1]).addClass('show-line');
                    }
                    dateIndex++;

                    // If all dates are shown, reveal the arrow
                    if (dateIndex === $dates.length) {
                        if (currentIndex < totalSlides - 1) {
                            $nextArrow.removeClass('dont-show').addClass('show');
                        }
                    }
                }

                updateArrowVisibility();
            });

            // Click event for custom arrow to go to the next slide in Slick.js
            $nextArrow.on('click', function () {
                $('.timeline-carousel-container').slick('slickNext');
            });
            $prevArrow.on('click', function () {
                $('.timeline-carousel-container').slick('slickPrev');
            });
        });
        updateArrowVisibility();
    }

    if ( $('body .bg-images-descriptions-container').length > 0 ) {
        $('.bg-images-descriptions-container').slick({
            dots: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
        });
    }

    if ($('body .cards-carousel-section').length > 0) {
        $('.cards-carousel-section .card-carousel').slick({
            // centerMode: true,
            // centerPadding: "70px",
            dots: true,
            arrows: true,
            infinite: false,
            slidesToShow: 3,
            autoplay: false,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        centerPadding: "100px",
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: "30px",
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: "30px",
                    }
                }, {
                    breakpoint: 280,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: "20px",
                    }
                }
            ]
        });
    }

    if ($('body .featured-products-carousel').length > 0) {
        $('.featured-products-carousel .related-products').slick({
            // centerMode: true,
            // centerPadding: "70px",
            dots: true,
            arrows: false,
            infinite: false,
            slidesToShow: 3,
            autoplay: false,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        centerPadding: "100px",
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: "30px",
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: "30px",
                    }
                }, {
                    breakpoint: 280,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: "20px",
                    }
                }
            ]
        });
    }

    if ($('body .youtube-embed-layout').length > 0) {
        $('.custom-video-thumbnail').on('click', function () {
            const $wrapper = $(this).closest('.video-wrapper');
            const $iframe = $wrapper.find('.youtube-iframe');
            const videoSrc = $iframe.data('src');

            // Hide thumbnail and show iframe
            $(this).fadeOut(300, function () {
                $iframe.attr('src', videoSrc).fadeIn(300);
            });
        });
    }
});